
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // Initialisation SYNCHRONE : on lit le viewport dès le 1er rendu (au lieu de
  // partir de `undefined`→`false` puis corriger dans un effet). Sans ça, sur un
  // vrai mobile le composant rendait d'abord la version "desktop" (ex. <video>),
  // déclenchant un re-rendu complet + des téléchargements inutiles avant que
  // l'effet ne corrige. Le garde `typeof window` couvre le SSR/prerender.
  const [isMobile, setIsMobile] = React.useState<boolean>(() =>
    typeof window !== "undefined"
      ? window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches
      : false
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
